import ReactJsonView from "@microlink/react-json-view";
import moment from "moment";
import { useMemo, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { FaDatabase } from "react-icons/fa";
import { useParams } from "react-router";

import { getRtdbConsoleUrl } from "../../api/rtdbBaseApi";
import {
    DroneStateRtdbDocument,
    useDroneWidgetsRtdbDocument,
} from "../../api/rtdbWrappers.generated";
import { Breadcrumbs, breadcrumbPaths } from "../../components/Breadcrumbs";
import Layout, { Title } from "../../components/Layout/Layout";

function convertTimestamps(obj) {
    if (Array.isArray(obj)) {
        return obj.map(convertTimestamps);
    }

    if (obj && typeof obj === "object") {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => {
                if (
                    (key === "serverTs" || key === "droneTs") &&
                    typeof value === "number"
                ) {
                    return [
                        key,
                        moment(value).format("YYYY-MM-DD HH:mm:ss.SSS (Z)"),
                    ];
                }

                return [key, convertTimestamps(value)];
            }),
        );
    }

    return obj;
}

function compactWidgetData(obj) {
    if (Array.isArray(obj)) {
        return obj.map(compactWidgetData);
    }

    if (obj && typeof obj === "object") {
        if (
            Object.hasOwn(obj, "data") &&
            (Object.hasOwn(obj, "droneTs") || Object.hasOwn(obj, "serverTs"))
        ) {
            return compactWidgetData(obj.data);
        }

        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
                key,
                compactWidgetData(value),
            ]),
        );
    }

    return obj;
}

export default function DroneNerdPage() {
    const { droneId } = useParams();
    const [droneWidgets] = useDroneWidgetsRtdbDocument(droneId);
    const [compactMode, setCompactMode] = useState(true);

    const widgetsForDisplay = useMemo(() => {
        const widgets = convertTimestamps(droneWidgets);
        return compactMode ? compactWidgetData(widgets) : widgets;
    }, [droneWidgets, compactMode]);

    return (
        <Layout>
            <title>{`${droneId} Nerd | MyCorvus`}</title>
            <Breadcrumbs path={breadcrumbPaths.droneNerd} />
            <Card>
                <Title title="Drone nerd">
                    <Button
                        variant="outline-secondary"
                        onClick={() =>
                            window.open(
                                getRtdbConsoleUrl(
                                    DroneStateRtdbDocument(droneId).path,
                                ),
                            )
                        }
                    >
                        <FaDatabase className="me-2" />
                        Firebase
                    </Button>
                </Title>
                {widgetsForDisplay && (
                    <div className="mx-4">
                        <Form.Check
                            type="switch"
                            id="compact-mode-switch"
                            label="Use compact mode"
                            checked={compactMode}
                            onChange={(e) => setCompactMode(e.target.checked)}
                            className="mb-3"
                        />
                        <ReactJsonView
                            src={widgetsForDisplay}
                            name={null}
                            theme="bright:inverted"
                            iconStyle="triangle"
                            enableClipboard={true}
                            collapsed={false}
                            displayObjectSize={false}
                            displayDataTypes={false}
                            sortKeys={true}
                            quotesOnKeys={false}
                        />
                    </div>
                )}
            </Card>
        </Layout>
    );
}
